<template>
<div style="width: 100%;height: 100%;">
  <section class="audit-main-chart-wrapper">
    <section class="audit-main-chart-header">
      <h3 class="chart-header-title">异常统计</h3>

      <section class="chart-header-toolbar">
        <unit-switch
          :default-unit-prop.sync="unitProp"
          size="mini"
          @change="onUnitPropChange"
        />
        <el-radio-group v-model="exceptionType" size="mini" @change="onExceptionTypeChanged">
          <el-radio-button :label="-1">查看全部</el-radio-button>
          <el-radio-button :label="2">只看异常</el-radio-button>
          <el-radio-button :label="1">只看人工</el-radio-button>
        </el-radio-group>

        <el-button
          type="warning"
          size="mini"
          @click="legendselectchanged"
        >反选</el-button>

        <el-button
          :disabled="exceptionType === 1"
          type="warning"
          size="mini"
          icon="el-icon-check"
          style="margin-left:.1em"
          @click="onSelectAllExceptionBtnClick"
        >全选未审核异常</el-button>

        <el-button
          :disabled="exceptionType === 2"
          type="success"
          size="mini"
          icon="el-icon-check"
          style="margin-left:0"
          @click="onSelectAllReserveBtnClick"
        >全选保留</el-button>

        <el-button
          :disabled="exceptionType === 2"
          type="danger"
          size="mini"
          icon="el-icon-check"
          style="margin-left:0"
          @click="onSelectAllDeleteBtnClick"
        >全选剔除</el-button>

        <el-button
          size="mini"
          icon="el-icon-close"
          style="margin-left:0"
          @click="onCancelSelectAllBtnClick"
        >取消选择</el-button>

        <el-button
          v-if="(hasAuditBtn || stage === -1 >>> 1) && !monthAuditDataMap[new Date(dataTimes[0]).format('YYYY/MM')]"
          type="primary"
          :disabled="selectedList.length === 0"
          size="mini"
          icon="el-icon-mouse"
          style="margin-left: .1em"
          @click="onProcessBtnClick"
        >处理</el-button>
      </section>
    </section>

    <section class="audit-main-chart-body">
      <e-chart
        ref="chart"
        @initialized="onChartInitialized"
        @destroy="onChartDestroy"
      />
    </section>
  </section>
</div>
</template>

<script>
import BaseStore from '../../../components/BaseStore'
import manualOperatorTypes from './manualOperatorTypes'
import unitConverter from '@/utils/unitConverter'

import {
  SHOW_PROCESS_PANEL
} from './EventKeys'
import EChart from '../../../components/Charts/ECharts'
import WindDirectionUtil from '../../../model/WindDirectionUtil'

export default {
  name: 'AuditMainChart',
  components: {EChart},
  extends: BaseStore,
  props: {
    stage: {
      required: true,
      type: Number
    },
    hasAuditBtn: {
      required: true,
      type: Number
    },
    monthAuditDataMap: {
      required: true,
      type: Object
    },
    auditRuleCategories: {
      required: true,
      type: Array
    },
    dataList: {
      required: true,
      type: Array
    },
    dataTimes: {
      required: true,
      type: Array
    },
    selectedFactorIds: {
      required: true,
      type: Array
    },
    selectedList: {
      required: true,
      type: Array
    },
    defaultUnitProp: {
      type: String,
      default: 'displayUnit'
    }
  },
  data () {
    return {
      exceptionType: -1,
      data: [],
      currentSelectLegend: {},
      // unitProp: 'stdUnit'
      unitProp: this.defaultUnitProp
    }
  },
  computed: {
    manualOperatorTypes: () => manualOperatorTypes,
    auditCategories () {
      return [...this.auditRuleCategories, {
        id: 'DERROR',
        name: '状态参数异常',
        flags: ['DERROR'],
        themeType: 'error'
      }, {
        id: 'QERROR',
        name: '质控异常',
        flags: ['QERROR'],
        themeType: 'error'
      }, ...this.manualOperatorTypes]
    },
    auditRuleCategoryMap () {
      return this.auditCategories.reduce((map, auditRuleCategory) => {
        return auditRuleCategory.flags.reduce((map, flag) => {
          map[flag] = auditRuleCategory.name
          return map
        }, map)
      }, {})
    },
    filterFactors () {
      return Object.values(this.factorMap)
    },
    unitChangeDataList () {
      let { unitProp, dataList } = this
      return dataList.map(el => {
        return {
          ...el,
          data: el.data.map(item => {
            return {
              ...item,
              value: Number(unitConverter(item.value, el.stdUnit, el[unitProp], el.molecular).toFixed(el.decimalNum))
            }
          })
        }
      })
    },
    dataMap () {
      return this.unitChangeDataList.reduce((map, data) => {
        map[data.id] = data
        return map
      }, {})
    }
  },
  watch: {
    selectedFactorIds () {
      setTimeout(() => {
        this.renderChart()
      }, 0)
    }
  },
  methods: {
    onUnitPropChange (unit) {
      this.unitProp = unit
      this.$eventBus.emit('setCurrentUnitKey', this.unitProp)

      setTimeout(() => {
        this.renderChart()
      }, 0)
    },
    // onAuditDataListChanged () {
    //   this.renderChart()
    // },
    onExceptionTypeChanged (exceptionType) {
      this.renderChart()
    },
    onProcessBtnClick () {
      this.$eventBus.emit(SHOW_PROCESS_PANEL, {auditDataList: this.selectedList, unit: this.unitProp})
    },
    onSelectAllExceptionBtnClick () {
      this.setSelectedList(data => data.autoFlag === 'N' || data.auditFlag)
    },
    onSelectAllReserveBtnClick () {
      this.setSelectedList(data => data.auditFlag !== 'RESERVE')
    },
    onSelectAllDeleteBtnClick () {
      this.setSelectedList(data => data.auditFlag !== 'DELETE')
    },
    setSelectedList (callback) {
      let chartOpt = this.getChartOpt()

      if (!chartOpt) {
        return
      }

      let {selectedList} = this
      let selectedMap = selectedList.reduce((map, selected) => {
        map[selected.id] = selected
        return map
      }, {})

      chartOpt.series.forEach(seriesItem => {
        let factorId = seriesItem.id

        seriesItem.data.forEach(data => {
          let dataId = data.id

          if (dataId === null || selectedMap[dataId] || callback(data)) {
            return
          }

          selectedList.push(this.reduceData(factorId, data))
        })
      })

      this.renderChart()
    },
    onCancelSelectAllBtnClick () {
      this.$emit('update:selectedList', [])
      setTimeout(() => {
        this.renderChart()
      }, 0)
    },
    onChartClick (param) {
      let {data} = param

      if (!data.canClick) {
        return
      }

      let factorId = param.seriesId
      let {dataTime} = data
      let {selectedList} = this

      if (data.isSelected) {
        let oSymbol = data.oSymbol

        if (oSymbol) {
          data.symbol = oSymbol
        } else {
          delete data.symbol
        }

        data.symbolSize = data.oSymbolSize
        data.isSelected = false

        let index = selectedList.findIndex(selected => selected.factorId === factorId && selected.dataTime.format('YYYY/MM/DD HH:mm:ss') === dataTime)

        if (index > -1) {
          selectedList.splice(index, 1)
        }
      } else {
        data.oSymbol = data.symbol
        data.oSymbolSize = data.symbolSize
        data.symbol = 'image:///static/imgs/chart_check.png'
        data.symbolSize = 16
        data.isSelected = true
        selectedList.push(this.reduceData(factorId, data))
      }

      this.getRefChart().setOpt({}, true)
    },
    reduceData (factorId, data) {
      return {
        id: data.id,
        factorId,
        dataTime: Object.freeze(new Date(data.dataTime)),
        dasValue: data.dasValue,
        dasFlag: data.dasFlag,
        value: data.value,
        autoFlag: data.autoFlag,
        auditFlag: data.auditFlag,
        auditComment: data.auditComment,
        originalFlag: data.originalFlag,
        originalValue: data.originalValue
      }
    },
    onChartInitialized (chart) {
      chart.on('click', this.onChartClick)

      if (this.selectedFactorIds.length > 0) {
        this.renderChart()
      }

      this.initialized = true
    },
    onChartDestroy (chart) {
      this.initialized = false
      chart.off('click', this.onChartClick)
    },
    renderChart () {
      let {selectedFactorIds, dataMap, currentSelectLegend} = this
      let allData = selectedFactorIds.map(factorId => dataMap[factorId])
      let dataList = JSON.parse(JSON.stringify(allData)).map(factorData => {
        factorData.data.forEach(item => {
          if (item.auditFlag === 'DELETE' && (item.dasFlag === 'c' || item.dasFlag === 'C')) {
            item.value = ''
          }
        })

        return factorData
      })

      let yAxis = this.getYAxis(dataList)
      let oldChartOpt = this.getChartOpt()
      let legendSelected = {}

      if (oldChartOpt) {
        legendSelected = oldChartOpt.legend[0].selected
      }

      let chartOpt = {
        tooltip: {
          trigger: 'item',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: 'rgba(0, 0, 0, .5)'
            }
          },
          formatter: param => {
            let data = param.data
            let {autoFlag, auditFlag} = data
            let {auditRuleCategoryMap} = this
            let eles = [
              `<section style="padding:0 .5em"><span>数据时间：${new Date(data.dataTime).format('YYYY-MM-DD HH时')}</span>`,
              `<span>因子名称：${param.seriesName}</span>`,
              `<span><span style="letter-spacing:.5em;">监测</span>值：<span ${Number.isFinite(data.originalValue) ? 'style="color: #67C23A;text-decoration: underline;"' : ''}>${data.factorId === '1013' ? this.windDirectionUtil.getWindDirName(data.value) : data.value}</span></span>`,
              `<span>数采标记：${data.dasFlag}</span>`,
              `<span>自动审核：${!autoFlag || autoFlag === 'N' ? '有效' : (autoFlag ? autoFlag.split('|').map(autoFlag => auditRuleCategoryMap[autoFlag]).join(',') : '')}</span>`
              // `<span>人工审核：${!auditFlag ? '--' : (auditFlag === 'N' ? '有效' : auditRuleCategoryMap[auditFlag])}</span>`
            ]

            if (auditFlag) {
              eles.push(`<span>人工审核：${auditFlag === 'N' ? '有效' : auditRuleCategoryMap[auditFlag]}</span>`)
              eles.push(`<span>异常原因：${data.auditComment}</span>`)
            }

            return eles.join('<br />')
          }
        },
        legend: {
          top: 10,
          // right: 36,
          left: 'center',
          borderWidth: 1,
          borderColor: '#E4F0FF',
          borderRadius: 3,
          padding: [2, 20, 2, 20],
          height: 20,
          textStyle: {
            fontSize: 11
          },
          type: 'scroll',
          selected: Object.values(currentSelectLegend).length === 0 ? dataList.reduce((map, data) => {
            let {name} = data
            map[name] = legendSelected[name] !== false
            return map
          }, {}) : currentSelectLegend
        },
        grid: {
          top: 65,
          right: 20,
          bottom: 50,
          left: 15,
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.dataTimes.map(date => date.format('MM-DD HH')),
          axisTick: {
            show: false
            // alignWithLabel: true
          },
          axisLabel: {
            margin: 12
          }
        }],
        yAxis,
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 14,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: dataList,
        animation: false
      }

      this.getRefChart().setOpt(chartOpt)

      this.currentSelectLegend = Object.values(currentSelectLegend).length === 0 ? dataList.reduce((map, data) => {
        let {name} = data
        map[name] = legendSelected[name] !== false
        return map
      }, {}) : currentSelectLegend

      let myChart = this.getRefChart().myChart
      let that = this
      myChart.on('legendselectchanged', function (data) {
        that.currentSelectLegend = data.selected
      })
    },
    legendselectchanged () {
      let currentSelectLegend = JSON.parse(JSON.stringify(this.currentSelectLegend))
      if (!currentSelectLegend) return
      for (let key in currentSelectLegend) {
        currentSelectLegend[key] = !currentSelectLegend[key]
      }
      this.currentSelectLegend = currentSelectLegend
      this.renderChart()
    },
    getYAxis (dataList) {
      let yAxis

      if (dataList.length > 0) {
        let lastSelectedList = this.selectedList
        let unitProp = this.unitProp
        let selectedList = []
        let lastSelectedMap = lastSelectedList.reduce((map, data) => {
          map[data.id] = data
          return map
        }, {})
        let units = [...new Set(dataList.map(data => data[unitProp]))]
        let unitMap = units.reduce((map, unit, index) => {
          map[unit] = index
          return map
        }, {})

        yAxis = units.map((unit, index) => ({
          type: 'value',
          name: unit,
          nameTextStyle: index === 0 ? {} : {
            padding: [0, 0, 0, 30]
          },
          offset: Math.max(index - 1, 0) * 30,
          splitLine: {
            show: index === 0
          }
        }))

        let {exceptionType} = this
        let allExceptionType = exceptionType | 1073741824

        dataList.forEach(data => {
          let {unit} = data
          data.type = 'line'
          data.yAxisIndex = unitMap[unit]

          data.data.forEach(data => {
            let n = allExceptionType

            while (n !== 0) {
              let a = -n & n
              let fn = chartNodeFn[a]

              if (fn(data)) {
                let selectedData = lastSelectedMap[data.id]

                if (selectedData && (n & exceptionType)) {
                  data.oSymbol = data.symbol
                  data.oSymbolSize = data.symbolSize
                  data.symbol = 'image:///static/imgs/chart_check.png'
                  data.isSelected = true
                  selectedList.push(selectedData)
                } else {
                  data.isSelected = false
                }
                break
              }

              n ^= a
            }
          })
        })

        this.$emit('update:selectedList', selectedList)
      } else {
        this.$emit('update:selectedList', [])
        yAxis = [{
          type: 'value'
        }]
      }

      return yAxis
    },
    getRefChart () {
      return this.$refs.chart
    },
    getChartOpt () {
      return this.getRefChart().getOpt()
    }
  },
  created () {
    this.windDirectionUtil = new WindDirectionUtil(WindDirectionUtil.WIND_DIRECTION_NAMES_8)
  }
}

const chartNodeFn = {
  1: data => {
    let auditFlag = data.auditFlag

    if (auditFlag) {
      data.symbol = `image:///static/imgs/${auditFlag}.svg`
      data.symbolSize = 16
      data.canClick = true
      return true
    }

    return false
  },
  2: data => {
    let autoFlag = data.autoFlag

    if (autoFlag && autoFlag !== 'N') {
      data.symbol = `image:///static/imgs/exception.svg`
      data.symbolSize = 16
      data.canClick = true
      return true
    }

    return false
  },
  4: data => {
    delete data.symbol
    data.symbolSize = 16
    data.canClick = true
    return true
  },
  1073741824: data => {
    delete data.symbol
    delete data.symbolSize
    data.canClick = false
    return true
  }
}
</script>

<style lang="scss" scoped>
.audit-main-chart-wrapper {
  position: relative;
  display: grid;
  grid-template-rows: max-content auto;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }

  > .audit-main-chart-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 10px 0;
  }

  > .audit-main-chart-body {
    width: 100%;
    height: 100%;
    border: 1px solid #EBEEF5;
  }

  .chart-header-title {
    font-size: 1rem;
    float: left;
    line-height: 1.75;
    margin: 0;
  }

  .chart-header-toolbar {
    float: right;
  }
}
.related-chart-wrapper {
  width: 100%;
  height: 100%;
  border: 1px solid #EBEEF5;
  overflow: auto;
  padding: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > .related-chart-body {
    width: 33%;
    height: 300px;
    border: 1px solid #EBEEF5;
    margin-bottom: 5px;
  }
}
.species-chart-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;

  > .species-chart-body {
    width: 100%;
    height: 100%;
    padding: 5px;

    > div {
      width: 100%;
      height: 300px;
    }
  }
}

.chart-header-toolbar {
  /deep/ .el-button{
    padding: 7px 12px;
  }

  /deep/ .el-radio-button__inner {
    padding: 7px 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditMainChart.vue